import React from 'react'
import { CircularProgress, LinearProgress, Paper } from 'react-md'
import { UploadField } from '@navjobs/upload'

import { UploadStatus } from 'api/enums'

import './index.css'

const ThumbnailImage = ({ image, progress, status, onUpload }) => (
  <Paper zDepth={2}>
    { image ? (
      <div className='thumbnail-image'>
        { onUpload ? (
          <UploadField
            onFiles={onUpload}
            uploadProps={{
              accept: '.jpg,.jpeg,.png',
              multiple: false
            }}
          >
            <img className='pointer' src={image} alt='thumbnail' width='100%' />
          </UploadField>
        ) : (
          <img src={image} alt='thumbnail' width='100%' />
        ) }
      </div>
    ) : (
      <div className='no-thumbnail'>
        { progress ? (
          <div>
            { status === UploadStatus.FAILED ? (
              <div className='progress-value md-headline'>
                No image
              </div>
            ) : (
              <div>
                <div className='progress-value md-display-1'>
                  { `${progress}%` }
                </div>
                <LinearProgress
                  id='thumbnail-upload-progress'
                  value={progress}
                />
              </div>
            ) }
          </div>
        ) : (
          <div className='progress-value'>
            <CircularProgress
              id='thumbnail-upload-progress'
              style={{ position: 'absolute' }}
            />
          </div>
        ) }
      </div>
    ) }
  </Paper>
)

export default ThumbnailImage



// WEBPACK FOOTER //
// ./src/components/ThumbnailImage/index.js